import axios from "axios";
import { LOGIN_BASE_PATH } from "./api-base-paths";

export const Loginuser = (data ) => {
    console.log("login",data)
    return axios.post(`${LOGIN_BASE_PATH}/loginuser`, data)
  };
